import { translateText } from "infra/translation/translate";
import { TabPanel, TabView } from "primereact/tabview";
import { Toast } from "primereact/toast";
import React, { useMemo, useRef } from "react";
import ScheduleVacation from "../ScheduleVacation";
import { VacationSetting } from "../VacationSetting";
import { useRolesStore } from "presentation/stores/use-roles-list-store";
import Spinner from "presentation/components/Shared/Spinner";
import { useAuthStore } from "presentation/stores/use-auth-store";
import { useRoleByFilter } from "presentation/hooks/use-query-role";
import { RoleInputFilter } from "domain/models/role-input-filter";
import { VacationAnalysis } from "../VacationAnalysis";

const VacationsPanel: React.FC = () => {

  const toast = useRef<Toast>(null);

  const rolesAllAllowed = ["RH", "Admin"];

  const { userPermissions, userEmployee } = useAuthStore();
  const { data: rolesData, isLoading: areRolesLoading } = useRoleByFilter({
    limit: 100,
  } as RoleInputFilter);
  
  const hasManagerPermission = userEmployee?.jobTitle.isPeopleManager;

  const hasAdminTabPermission = useMemo(() => {
    if (!rolesData?.data || !userPermissions) {
      return false;
    }
    const allowedRoleIds = rolesData.data
      .filter((role) => rolesAllAllowed.includes(role.name))
      .map((role) => role.id);

    return userPermissions.some((permission) =>
      allowedRoleIds.includes(permission.roleId)
    );
  }, [rolesAllAllowed, userPermissions]);

  if ( areRolesLoading) {
    return <Spinner />;
  }

  return (
    <div>
      <div className="card">
        <TabView>
          <TabPanel
            header={translateText("Schedule vacation", "pt")}
            leftIcon="pi pi-calendar-clock mr-2"
          >
            <ScheduleVacation />
          </TabPanel>

          {(hasManagerPermission || hasAdminTabPermission) && (
            <TabPanel
              header={translateText("Vacation list", "pt")}
              leftIcon="pi pi-list mr-2"
            >
              <VacationSetting isAdmin={hasAdminTabPermission} isManager={hasManagerPermission} />
            </TabPanel>
          )}

          {(hasAdminTabPermission) && (
            <TabPanel
              header={"Análise"}
              leftIcon="pi pi-chart-bar mr-2"
            >
              <VacationAnalysis />
            </TabPanel>
          )}

        </TabView>
        <div className="next-bottom"></div>
        <Toast ref={toast} position="bottom-right" />
      </div>
    </div>
  );
};

export default VacationsPanel;
